import { z } from '../zod';

const ABANDONMENT_EMAIL_STATUSES = Object.freeze({
  pending: 'pending',
  firstSent: 'first_sent',
  secondSent: 'second_sent',
  thirdSent: 'third_sent',
  // Not yet a valid value.
  // converted: 'converted',
  skipped: 'skipped',
});

export const SubscriptionAbandonmentEmailStatusValidationEnum = z.enum(ABANDONMENT_EMAIL_STATUSES);

export const SUBSCRIPTION_STATUSES = Object.freeze({
  draft: 'draft',
  draftExpired: 'draft_expired',
  incomplete: 'incomplete',
  incompleteExpired: 'incomplete_expired',
  trialing: 'trialing',
  paused: 'paused',
  scheduled: 'scheduled', // internal status for subscriptions that have a start date in the future
  active: 'active',
  pastDue: 'past_due',
  canceled: 'canceled',
  unpaid: 'unpaid',
  failed: 'failed',
  completed: 'completed',
});

export const SubscriptionStatusValidationEnum = z.enum(SUBSCRIPTION_STATUSES);

export type SubscriptionStatus = z.infer<typeof SubscriptionStatusValidationEnum>;

const SUBSCRIPTION_PAYMENT_STATUSES = Object.freeze({
  draft: 'draft',
  deleted: 'deleted',
  open: 'open',
  paid: 'paid',
  uncollectible: 'uncollectible',
  void: 'void',
  requiresPaymentMethod: 'requires_payment_method',
  requiresConfirmation: 'requires_confirmation',
  requiresAction: 'requires_action',
  processing: 'processing',
  requiresCapture: 'requires_capture',
  canceled: 'canceled',
  succeeded: 'succeeded',
});

export const SubscriptionPaymentStatusValidationEnum = z.enum(SUBSCRIPTION_PAYMENT_STATUSES);

const SUBSCRIPTION_INTERVALS = Object.freeze(['day', 'week', 'month', 'year']);
export const SubscriptionIntervalValidationEnum = z.enum(SUBSCRIPTION_INTERVALS);

const SUBSCRIPTION_ABANDONMENT_STATUS = Object.freeze(['abandoned', 'recovered']);
export const SubscriptionAbandonmentStatusValidationEnum = z.enum(SUBSCRIPTION_ABANDONMENT_STATUS);
